/**
 * New Relic Browser Agent — currently DISABLED to stay within free-tier data limits.
 *
 * To re-enable, restore the NREUM initialization and SPA loader script.
 * See git history or docs/newrelic.md for the previous configuration.
 */
export default defineNuxtPlugin(() => {
  // Browser agent disabled — no-op
})
